import React, { useContext, useRef, useState, useMemo } from 'react'
import { Dialog, Button, DialogContent, DialogContentText, DialogActions } from '@mui/material'

const ConfirmationModalContext = React.createContext({})

const ConfirmationModalContextProvider = ({ children }) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [content, setContent] = useState('')
  const resolver = useRef(null)

  const confirm = (content) => {
    setContent(content)
    setShowConfirmationModal(true)

    return new Promise((resolve) => {
      resolver.current = resolve
    })
  }

  const handleOk = () => {
    if (resolver.current) {
      resolver.current(true)
      resolver.current = null
    }
    setShowConfirmationModal(false)
  }

  const handleCancel = () => {
    if (resolver.current) {
      resolver.current(false)
      resolver.current = null
    }
    setShowConfirmationModal(false)
  }

  const contextValue = useMemo(() => ({ confirm }), [])

  return (
    <ConfirmationModalContext.Provider value={contextValue}>
      {children}

      <Dialog
        open={showConfirmationModal}
        aria-labelledby='confirmation-dialog-title'
        aria-describedby='confirmation-dialog-description'
      >
        <DialogContent>
          <DialogContentText id='confirmation-dialog-description'>{content}</DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancel}>Non</Button>
          <Button onClick={handleOk} autoFocus>
            Oui
          </Button>
        </DialogActions>
      </Dialog>
    </ConfirmationModalContext.Provider>
  )
}

export const useConfirmationModalContext = () => useContext(ConfirmationModalContext)
export default ConfirmationModalContextProvider
